import api from '../api';
import util from '../util';

const getDefaultState = () => ({
    tags: [],
    hasQuried: false,
    modalShown: false,
    modalForTagEditingShown: false,
    modalForTagRemovingShown: false,
    nameField: null,
    tagInEditing: null,
    tagInRemoving: null,
});

export const tagList = {
    namespaced: true,

    state: getDefaultState(),

    getters: {

        dataIsValid(state) {
            return state.nameField &&
                state.tags.every(tag => tag.name.trim() != state.nameField);
        }

    },

    mutations: {
        setTags(state, tags) {
            state.tags = tags;
        },
        setHasQuried(state, hasQuried) {
            state.hasQuried = hasQuried;
        },
        setModalShown(state, modalShown) {
            state.modalShown = modalShown;
        },
        setModalForTagEditingShown(state, modalForTagEditingShown) {
            state.modalForTagEditingShown = modalForTagEditingShown;
        },
        setModalForTagRemovingShown(state, modalForTagRemovingShown) {
            state.modalForTagRemovingShown = modalForTagRemovingShown;
        },
        setNameField(state, nameField) {
            state.nameField = nameField;
        },
        setTagInEditing(state, tagInEditing) {
            state.tagInEditing = tagInEditing;
        },
        setTagInRemoving(state, tagInRemoving) {
            state.tagInRemoving = tagInRemoving;
        },
        resetState(state) {
            Object.assign(state, getDefaultState());
        },
    },

    actions: {

        fetchRetailersTags({ commit }) {

            api.getRetailersTags()
                .then(
                    res => {
                        let tags = res.data.data;
                        commit('setTags', tags);
                        commit('setHasQuried', true);
                    }
                )
        },

        quit({ commit }) {
            commit('setTags', []);
            commit('setHasQuried', false);
        },

        createTag({ dispatch }, { tagName }) {
            api.createTag(tagName)
                .then(
                    () => {
                        dispatch('closeModal');
                        dispatch('fetchRetailersTags');
                    },
                    () => {
                        dispatch('message/error', { title: 'Error', content: 'create tag unsuccessfully.' }, { root: true })
                    }
                );
        },

        updateTag({ dispatch }, { tag }) {
            api.updateTag(tag)
                .then(
                    () => {
                        dispatch('closeModalForTagEditing');
                        dispatch('fetchRetailersTags');
                    },
                    () => {
                        dispatch('message/error', { title: 'Error', content: 'update tag unsuccessfully.' }, { root: true })
                    }
                );
        },

        removeTag({ dispatch }, { tag }) {
            api.removeTag(tag)
                .then(
                    () => {
                        dispatch('closeModalForTagRemoving');
                        dispatch('fetchRetailersTags');
                    },
                    () => {
                        dispatch('message/error', { title: 'Error', content: 'remove tag unsuccessfully.' }, { root: true })
                    }
                );
        },

        openModal({ commit }) {
            commit('setModalShown', true);
        },

        closeModal({ commit }) {
            commit('setModalShown', false);
            commit('setNameField', null);
        },

        openModalForTagEditing({ commit }, { tag }) {
            commit('setModalForTagEditingShown', true);
            commit('setTagInEditing', util.copyObj(tag));
        },

        closeModalForTagEditing({ commit }) {
            commit('setModalForTagEditingShown', false);
            commit('setTagInEditing', null);
        },

        openModalForTagRemoving({ commit }, { tag }) {
            commit('setModalForTagRemovingShown', true);
            commit('setTagInRemoving', util.copyObj(tag));
        },

        closeModalForTagRemoving({ commit }) {
            commit('setModalForTagRemovingShown', false);
            commit('setTagInRemoving', null);
        },


    }

};